import React, { useState } from "react";
import { useLanguage } from "../LanguageProvider";

export default function OfferRequestModal({ onClose }) {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    houseType: "",
    size: "",
    hasPlot: "",
    comment: ""
  });
  const [submitted, setSubmitted] = useState(false);

  const { dict } = useLanguage();
  const offerDict = dict.offer || {};
  const houseTypes = [
    "10-15 millió forint között",
    "20-25 millió forint között",
    "25 millió felett"
  ];
  const sizes = offerDict.sizes || [
    "30-40 m²",
    "41-50 m²",
    "51-60 m²",
    "61+ m²"
  ];

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }
  function handleSubmit(e) {
    e.preventDefault();
    fetch('/send_offer.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(form).toString(),
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) setSubmitted(true);
        else alert(offerDict.error || 'Nem sikerült elküldeni az ajánlatkérést. Próbáld újra!');
      })
      .catch(() => alert(offerDict.error || 'Hiba történt az ajánlatkérés közben.'));
  }

  if (submitted) {
    return (
      <div className="bg-white rounded-xl p-8">
        <div className="text-center">
          <div className="text-6xl mb-4">✅</div>
          <h2 className="text-2xl font-bold text-green-600 mb-2">{offerDict.success || 'Sikeres küldés!'}</h2>
          <p className="text-gray-600 mb-6">{offerDict.successMessage || 'Köszönjük az érdeklődését! Hamarosan felvesszük Önnel a kapcsolatot.'}</p>
          <button
            className="px-6 py-3 bg-[#e31937] hover:bg-[#b91c3c] text-white rounded-lg shadow font-medium transition-colors"
            onClick={onClose}
          >
            {offerDict.close || "Bezárás"}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6 md:p-8">
      <form onSubmit={handleSubmit} className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-white mb-1">{offerDict.name || 'Név'} *</label>
          <input
            type="text"
            name="name"
            value={form.name}
            onChange={handleChange}
            required
            className="w-full px-3 py-2 rounded-lg bg-white/20 backdrop-blur-sm border border-white/30 text-white placeholder-white/70 focus:outline-none focus:ring-2 focus:ring-white/50 focus:border-white/50"
            placeholder={offerDict.namePlaceholder || 'Teljes név'}
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-white mb-1">{offerDict.email || 'Email'} *</label>
          <input
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            required
            className="w-full px-3 py-2 rounded-lg bg-white/20 backdrop-blur-sm border border-white/30 text-white placeholder-white/70 focus:outline-none focus:ring-2 focus:ring-white/50 focus:border-white/50"
            placeholder={offerDict.emailPlaceholder || 'email@example.com'}
          />
        </div>
      </div>
      <div>
        <label className="block text-sm font-medium text-white mb-1">{offerDict.phone || 'Telefonszám'} *</label>
        <input
          type="tel"
          name="phone"
          value={form.phone}
          onChange={handleChange}
          required
          className="w-full px-3 py-2 rounded-lg bg-white/20 backdrop-blur-sm border border-white/30 text-white placeholder-white/70 focus:outline-none focus:ring-2 focus:ring-white/50 focus:border-white/50"
          placeholder={offerDict.phonePlaceholder || '+36 30 123 4567'}
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-white mb-1">{offerDict.budget || 'Költségkeret'}</label>
        <select
          name="houseType"
          value={form.houseType}
          onChange={handleChange}
          className="w-full px-3 py-2 rounded-lg bg-white/20 backdrop-blur-sm border border-white/30 text-white focus:outline-none focus:ring-2 focus:ring-white/50 focus:border-white/50"
        >
          <option value="" className="text-gray-900">{offerDict.selectBudget || 'Válassz költségkeretet'}</option>
          {houseTypes.map((type, index) => (
            <option key={index} value={type} className="text-gray-900">{type}</option>
          ))}
        </select>
      </div>
      <div>
        <label className="block text-sm font-medium text-white mb-1">{offerDict.size || 'Méret'}</label>
        <select
          name="size"
          value={form.size}
          onChange={handleChange}
          className="w-full px-3 py-2 rounded-lg bg-white/20 backdrop-blur-sm border border-white/30 text-white focus:outline-none focus:ring-2 focus:ring-white/50 focus:border-white/50"
        >
          <option value="" className="text-gray-900">{offerDict.selectSize || 'Válassz méretet'}</option>
          {sizes.map((size, index) => (
            <option key={index} value={size} className="text-gray-900">{size}</option>
          ))}
        </select>
      </div>
      <div>
        <label className="block text-sm font-medium text-white mb-1">{offerDict.hasPlot || 'Van saját telek?'}</label>
        <div className="flex gap-4">
          <label className="flex items-center">
            <input
              type="radio"
              name="hasPlot"
              value="igen"
              checked={form.hasPlot === 'igen'}
              onChange={handleChange}
              className="mr-2 text-white focus:ring-white/50"
            />
            <span className="text-white">{offerDict.yes || 'Igen'}</span>
          </label>
          <label className="flex items-center">
            <input
              type="radio"
              name="hasPlot"
              value="nem"
              checked={form.hasPlot === 'nem'}
              onChange={handleChange}
              className="mr-2 text-white focus:ring-white/50"
            />
            <span className="text-white">{offerDict.no || 'Nem'}</span>
          </label>
        </div>
      </div>
      <div>
        <label className="block text-sm font-medium text-white mb-1">{offerDict.comment || 'Megjegyzés'}</label>
        <textarea
          name="comment"
          value={form.comment}
          onChange={handleChange}
          rows={3}
          className="w-full px-3 py-2 rounded-lg bg-white/20 backdrop-blur-sm border border-white/30 text-white placeholder-white/70 focus:outline-none focus:ring-2 focus:ring-white/50 focus:border-white/50 resize-none"
          placeholder={offerDict.commentPlaceholder || 'További információk, kérések...'}
        />
      </div>
            <button
              type="submit"
              className="w-full mt-4 bg-[#e31937] hover:bg-[#b91c3c] text-white font-bold py-3 px-6 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-white/50 shadow-lg"
            >
              {offerDict.submit || 'Ajánlat kérek'}
            </button>
      </form>
    </div>
  );
}
